export default __webpack_public_path__ + "static/media/Camera.5f0bf63d.jpeg";